import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import Loading from "../../utility/Loading";
import { tokenService } from "../../../services/token.service";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const UnauthorizedAccess: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center max-w-md mx-auto p-6">
      <div className="bg-red-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
        <svg
          className="w-8 h-8 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Acceso Denegado
      </h2>
      <p className="text-gray-600 mb-4">
        No tienes permisos para acceder a esta sección.
      </p>
      <button
        onClick={() => window.history.back()}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Regresar
      </button>
    </div>
  </div>
);

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/login",
}) => {
  const { customerData, loading } = useAuth();
  const location = useLocation();

  // Mostrar spinner mientras carga
  if (loading) {
    return <Loading />;
  }

  const hasToken = !!tokenService.getToken();

  // Redirigir a login si no hay token (más directo para multi-pestaña)
  if (!hasToken) {
    return (
      <Navigate to={redirectTo} state={{ from: location.pathname }} replace />
    );
  }

  // Si todo está bien, mostrar el contenido
  return <>{children}</>;
};

// Componente para redirigir usuarios autenticados
interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

interface VerifyRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = "/customer/dashboard",
}) => {
  const { loading } = useAuth();

  if (loading) return <Loading />;

  const hasToken = !!tokenService.getToken();
  //const isVerified = tokenService.isUserVerified();
  
  if (hasToken) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export const VerifyRoute: React.FC<VerifyRouteProps> = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  return <>{children}</>;
};
